import { LayoutComponents } from "@jelly/lesson";

import components100hz from "./pressure/100-hz";
import components200hz from "./pressure/200-hz";
import components350hz from "./pressure/350-hz";
import components385hz from "./pressure/385-hz";
import components450hz from "./pressure/450-hz";
import components550hz from "./pressure/550-hz";
import components650hz from "./pressure/650-hz";
import components900hz from "./pressure/900-hz";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "dependentSelect",
      options: {
        selects: [
          {
            id: "a",
            label: "Frequency",
            labelPosition: "top",
            options: [
              { value: "1", label: "100 Hz" },
              { value: "2", label: "200 Hz" },
              { value: "3", label: "350 Hz" },
              { value: "4", label: "385 Hz" },
              { value: "5", label: "450 Hz" },
              { value: "6", label: "550 Hz" },
              { value: "7", label: "650 Hz" },
              { value: "8", label: "900 Hz" },
            ],
          },
          {
            id: "b",
            label: "Number of modes",
            labelPosition: "top",
            options: [
              { value: "1", label: "1 mode" },
              { value: "2", label: "2 modes", allowedOnly: { a: ["2", "3", "4", "5", "6", "7", "8"] } },
              { value: "3", label: "3 modes", allowedOnly: { a: ["3", "4", "5", "6", "7", "8"] } },
              { value: "4", label: "4 modes", allowedOnly: { a: ["4", "5", "6", "7", "8"] } },
              { value: "5", label: "5 modes", allowedOnly: { a: ["5", "6", "7", "8"] } },
              { value: "6", label: "6 modes", allowedOnly: { a: ["6", "7", "8"] } },
              { value: "7", label: "7 modes", allowedOnly: { a: ["7", "8"] } },
              { value: "8", label: "8 modes", allowedOnly: { a: ["8"] } },
              { value: "9", label: "9 modes", allowedOnly: { a: ["8"] } },
              { value: "10", label: "10 modes", allowedOnly: { a: ["8"] } },
              { value: "11", label: "11 modes", allowedOnly: { a: ["8"] } },
              { value: "12", label: "12 modes", allowedOnly: { a: ["8"] } },
              { value: "13", label: "13 modes", allowedOnly: { a: ["8"] } },
              { value: "14", label: "14 modes", allowedOnly: { a: ["8"] } },
            ],
          },
        ],
        components: {
          ...components100hz,
          ...components200hz,
          ...components350hz,
          ...components385hz,
          ...components450hz,
          ...components550hz,
          ...components650hz,
          ...components900hz,
        },
      },
    },
  },
];

export default components;
